module.exports = __webpack_public_path__ + "img/desc_bottom_vtcwm101.6129a2cb.png";